import { Bolt, LayoutDashboard, LogOut } from "lucide-react";
import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import styles from "../../_css/Header.module.css";
import { FOOTER } from "../../data/commonComponents";
import { useSelector } from "react-redux";
import HelpAndSupportModal from "../Modals/HelpAndSupportModal";

const Footer = () => {
  const [activeIcon, setActiveIcon] = useState(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const lang = useSelector((state) => state.language.lang);
  const { termsAndConditions, privacyPolicy, contactUs, aboutSalah } =
    FOOTER[lang];
  return (
    <Nav className={`${styles["footer-nav"]}`}>
      <div className="d-flex">
        <ul
          style={{ listStyle: "none", color: "#6B7280" }}
          className="d-flex gap-3 m-0 p-0"
        >
          <li
            onClick={() => {
              navigate("/terms-and-conditions");
            }}
            className={`${styles["nav-icon-footer"]} pe-cursor${
              pathname === "/terms-and-conditions" ? " " + styles["active"] : ""
            }`}
          >
            {termsAndConditions}
          </li>
          <li
            onClick={() => {
              // navigate("/contact-us");
              // setShowHelpModal(true);
              window.open("https://t.me/SmartsWay125", "_blank");
            }}
            className={`${styles["nav-icon-footer"]} pe-cursor${
              pathname === "/contact-us" ? " " + styles["active"] : ""
            }`}
          >
            {contactUs}
          </li>
          <li
            onClick={() => {
              navigate("/about-salah");
            }}
            className={`${styles["nav-icon-footer"]} pe-cursor${
              pathname === "/about-salah" ? " " + styles["active"] : ""
            }`}
          >
            {aboutSalah}
          </li>
        </ul>
      </div>
      <HelpAndSupportModal
        show={showHelpModal}
        onClose={() => setShowHelpModal(false)}
      />
    </Nav>
  );
};

export default Footer;
